(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hg-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var ease = function (t) { return 1 - Math.pow(1 - t, 3); };

    function countUp(el) {
      if (el.dataset.hgDone) return;
      el.dataset.hgDone = '1';
      var original = el.textContent.trim();
      var m = original.match(/^(\d+)([\s\S]*)$/);
      if (!m) return;
      var target = parseInt(m[1], 10);
      var suffix = m[2];
      if (target <= 1 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var duration = 1400;
      var start = null;
      el.textContent = '0' + suffix;
      function frame(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        el.textContent = Math.round(ease(p) * target) + suffix;
        if (p < 1) requestAnimationFrame(frame);
        else el.textContent = original;
      }
      requestAnimationFrame(frame);
    }

    function init() {
      var els = document.querySelectorAll('[data-hg-countup]:not([data-hg-done])');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) return;
      els.forEach(function (el) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              countUp(el);
              io.disconnect();
            }
          });
        }, { threshold: 0.6 });
        io.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
